import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconCheckCircle: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#00795B',
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00016 0.833496C4.04816 0.833496 0.833496 4.04883 0.833496 8.00016C0.833496 11.9515 4.04816 15.1668 8.00016 15.1668C11.9522 15.1668 15.1668 11.9515 15.1668 8.00016C15.1668 4.04883 11.9522 0.833496 8.00016 0.833496ZM8.00016 14.1668C4.5995 14.1668 1.8335 11.4008 1.8335 8.00016C1.8335 4.5995 4.5995 1.8335 8.00016 1.8335C11.4008 1.8335 14.1668 4.5995 14.1668 8.00016C14.1668 11.4008 11.4008 14.1668 8.00016 14.1668ZM10.6868 6.09082C10.8822 6.28615 10.8822 6.60284 10.6868 6.79818L7.5755 9.90951C7.47817 10.0068 7.35017 10.0562 7.22217 10.0562C7.09417 10.0562 6.96617 10.0075 6.86884 9.90951L5.3135 8.35417C5.11816 8.15883 5.11816 7.84214 5.3135 7.64681C5.50883 7.45148 5.8255 7.45148 6.02083 7.64681L7.22284 8.84884L9.98016 6.09151C10.1755 5.89618 10.4915 5.89615 10.6868 6.09082Z"
      fill={disabled ? 'rgba(92, 101, 110, 1)' : color}
    />
  </svg>
);

export default IconCheckCircle;
